import React, { useEffect, memo } from 'react';
import { hot } from 'react-hot-loader';
import TrustBox from '../TrustBox/TrustBox';
import { purifier } from '../../../utils/dom';
import s from './Embed.scss';

const areEqual = (prevProps, { content }) => {
	if (prevProps?.content?.rawText === content?.rawText) return true;
	return false;
};

const Embed = ({ content, product, currentPath, setup }) => {
	const embedClasses = [s.embed];
	if (content.rawText && content.rawText.indexOf('trustpilot') !== -1) return <TrustBox content={{ templateCode: content.rawText }} product={product} />;

	useEffect(() => {
		if (content.rawText && content.rawText.indexOf('g-recaptcha') !== -1 && !document.getElementById('js-g-recaptcha')) {
			const node = document.createElement('script');
			node.type = 'text/javascript';
			node.id = 'js-g-recaptcha';
			node.src = 'https://www.google.com/recaptcha/api.js';
			node.className = 'js-embedScripts';
			document.head.appendChild(node);
		}
		if (content.rawText && content.rawText.indexOf('g-ytsubscribe') !== -1 && !document.getElementById('js-g-ytsubscribe')) {
			const node = document.createElement('script');
			node.type = 'text/javascript';
			node.id = 'js-g-ytsubscribe';
			node.src = 'https://apis.google.com/js/platform.js';
			node.className = 'js-embedScripts';
			document.head.appendChild(node);
		}
		if (content.rawText && content.rawText.indexOf('lcly') !== -1 && !document.getElementById('js-lcly')) {
			const parsedConfig = content.rawText.match(/lcly_config_\d\s?=\s?({[^}]*})/)?.[1] || '{}';
			const lclyConfig = {
				company_name: 'Marsblade',
				button_text: 'Find it Locally',
				button_id: 'HTML',
				company_id: '186009',
				css: '4',
				always_hide_button: '1',
				show_location_switcher: '1',
				show_location_prompt: '1',
				lang: 'en-us',
				show_dealers: '1',
				n_dealers: '10',
				target: 'new',
				show_address: '1',
				radius_in_km: '10000',
				only_show_country: setup.country,
				...JSON.parse(parsedConfig),
			};
			const lclyQuery = Object.keys(lclyConfig).reduce((a, k) => {
				a.push(`${encodeURIComponent(k)}=${encodeURIComponent(lclyConfig[k])}`);
				return a;
			}, []).join('&');
			const node = document.createElement('script');
			node.type = 'text/javascript';
			node.id = 'js-lcly';
			node.src = `https://marsblade.locally.com/stores/map.js?${lclyQuery}`;
			node.className = 'js-embedScripts';
			document.head.appendChild(node);
		}
		if (content.rawText && content.rawText.indexOf('submitRuleOptin') !== -1) {
			window.submitRuleOptin = () => document.getElementById('rule-optin-form').submit();
		}

		return () => {
			[...document.head.querySelectorAll('.js-embedScripts')].map((node) => node && node.remove());
		};
	}, [content.rawText, currentPath]);

	if (content.rawText && content.rawText.indexOf('lcly') !== -1) {
		embedClasses.push(s.embed__lcly);
		if (content.rawText.indexOf('inline') !== -1) embedClasses.push(s.embed__lclyStoreLocator);
	}

	return (
		<div className={embedClasses.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, { ADD_TAGS: ['iframe', 'script'], KEEP_CONTENT: false }) }} />
	);
};

export default hot(module)(memo(Embed, areEqual));
